<template>
    <div>
        <p class="distance-info"><b>Mapa testowa</b> | Dystans z google: {{googleDistance}} Km poza strefą:{{kmOutZone}}</p>
        <div class="call-center-map">
            <div id="myMap"></div>
        </div>
        <textarea style="border: solid 2px #000; width: 100%; height: 100px;" v-show="false">{{circleTxt}}</textarea>
    </div>
</template>
<script>
    export default {
        name: 'callCenterMap',
        props: ['step', 'delivery', 'warehouse', 'deliveryAddress'],
        data () {
            return {
                circleTxt: '',
                map: null,
                directionsService: null,
                directionsRenderer: null,
                googleDistance: 0,
                divisionLocation: {},
                markers: [],
                zones: [],
                kmOutZone: '-',
                custLocation: {},
                mapZones: [],
                urls: {
                    getWhLocation: '/api/vendor/warehouse/',
                    getZones: '/api/warehouse/getZones/',
                    outOfZone: '/api/delivery/test/outOfZone/'
                }
            }
        },

        mounted: function () {
            var self = this;
            this.initMap();
            this.addMarker(52.229676,  21.012229, 'Warszawa');

            self.directionsService = new google.maps.DirectionsService();
            self.directionsRenderer = new google.maps.DirectionsRenderer();
            self.directionsRenderer.setMap(self.map);

            Event.$on('mapSetCustomLocation', function(custLocation) {
                if (custLocation) {
                    self.addMarker(custLocation.Lat, custLocation.Lng, "Klient");
                    self.custLocation = custLocation;
                }
                // jest custom loc i wh
                self.getDirections();
            });

            Event.$on('toMap', function(w) {
                self.showDivision(w);
            });
        },

        methods: {
            makeRouteTest: function() {
                // var points = [[23.080920000002,53.1488599999921],[23.0840400000021,53.1448999999921],[23.0841900000021,53.1443199999921],[23.0838900000021,53.1441999999921],[23.080580000002,53.1447599999922],[23.076350000002,53.1455099999923],[23.071850000002,53.1463199999924],[23.065190000002,53.1474499999925],[23.062740000002,53.1478999999926],[23.060050000002,53.1483499999926],[23.0555500000019,53.1491799999927],[23.0360400000019,53.1526499999931],[23.0213600000018,53.1552499999934],[23.0140700000018,53.1565699999936],[23.0101300000017,53.1571499999936],[22.9976500000017,53.1594499999939],[22.9958400000017,53.1597799999939],[22.9907700000017,53.160669999994],[22.9889200000017,53.160879999994],[22.9859000000016,53.1610399999941],[22.9820700000016,53.1611699999941],[22.9796700000016,53.1612999999942],[22.9765600000016,53.1616999999942],[22.9753400000016,53.1619299999943],[22.9724000000016,53.1626299999943],[22.9683600000016,53.1635299999944],[22.9660200000016,53.1638799999944],[22.9636100000016,53.1640799999945],[22.9532300000015,53.1643099999946],[22.9483000000015,53.1642999999947],[22.9418800000015,53.1643099999948],[22.9372500000015,53.1643899999949],[22.9289600000014,53.164539999995],[22.9266200000014,53.1645599999951],[22.9252500000014,53.1644999999951],[22.9223200000014,53.1641499999951],[22.9207000000014,53.1638899999951],[22.8992400000013,53.1604899999955],[22.8852200000013,53.1582299999957],[22.8795100000013,53.1573199999957],[22.8754500000013,53.1567799999958],[22.8697800000012,53.1559199999959],[22.8626400000012,53.154759999996],[22.8594300000012,53.154239999996],[22.8565200000012,53.1536799999961],[22.8513700000012,53.1528299999961],[22.8317700000011,53.1496599999963],[22.8207700000011,53.1478699999965],[22.798580000001,53.1442899999967],[22.778660000001,53.1410399999969],[22.770560000001,53.139759999997],[22.7559500000009,53.1373799999971],[22.7347200000009,53.1339599999974],[22.7169300000008,53.1310599999975],[22.7091000000008,53.1298199999976],[22.7022100000008,53.1286199999976],[22.6925600000008,53.1270299999977],[22.6895700000008,53.1264299999977],[22.6856000000008,53.1258399999978],[22.6797400000008,53.1251899999978],[22.6769600000007,53.1248999999978],[22.6706600000007,53.1239999999979],[22.6517400000007,53.120959999998],[22.6454400000007,53.1196999999981],[22.6422100000007,53.1190999999981],[22.6321800000007,53.1175199999982],[22.6281900000007,53.1170599999982],[22.6263900000006,53.1169299999982],[22.6235100000006,53.1167699999982],[22.6159000000006,53.1166099999983],[22.6112600000006,53.1164799999983],[22.6092400000006,53.1162999999983],[22.6075300000006,53.1160899999983],[22.6053857295919,53.1157231147267]]
                // this.drawLine(points, 'FF0000')
            },
            getCustAddressString: function() {
                return this.deliveryAddress.PostalCode + ' ' + this.deliveryAddress.City + ' ' + this.deliveryAddress.Street + ' ' + this.deliveryAddress.StreetNo;
            },

            getWhString: function() {
                return this.warehouse.PostalCode + ' ' + this.warehouse.City + ' ' + this.warehouse.Street + ' ' + this.warehouse.StreetNo;
            },

            getDirections: function () {
                var self = this;
                //define an array that will hold all the waypoints
                var waypnts = [];
                //define a directionsRequest object
                var directionRequest;


                var orig = new google.maps.LatLng(self.divisionLocation.lat, self.custLocation.lng);
                var dest = new google.maps.LatLng(self.custLocation.Lat, self.custLocation.Lng);
                console.log(JSON.stringify(orig));
                console.log(JSON.stringify(dest));

                orig = this.getWhString();
                dest = this.getCustAddressString();

                directionRequest = {
                    origin: orig,
                    destination: dest,
                    // provideRouteAlternatives: false,
                    travelMode: google.maps.TravelMode.DRIVING,
                    avoidHighways: true,
                    avoidTolls: true
                    // drivingOptions: {
                    //     trafficModel: 'optimistic',
                    //     departureTime: new Date(Date.now() + 1000)
                    // }
                };

                //send the request to the directionsService
                self.directionsService.route(directionRequest, function(result, status) {
                    if (status == google.maps.DirectionsStatus.OK) {
                        self.directionsRenderer.setDirections(result)
                        self.googleDistance = result.routes[0].legs[0].distance.text
                        console.log('EMIT - directionServiceResults')
                        Event.$emit('directionServiceResults', result)

                        self.$http.post(self.urls.outOfZone, {divisionId: self.warehouse.ID, routePath: result.routes[0].overview_polyline }).then(function (response) {
                            if (response.data.lineCoords) {
                                self.drawLine(response.data.lineCoords);

                                var pointsCount = response.data.lineCoords.length;
                                self.addMarker(response.data.lineCoords[pointsCount - 1][1], response.data.lineCoords[pointsCount - 1][0], "Pkt końcowy strefy");
                                self.kmOutZone = response.data.kmOutZone;
                                console.log('USTAWIAM kmOutZone IN CallCenter' + self.kmOutZone);
                                Event.$emit('kmOutZone', self.kmOutZone);
                            } else {
                                Event.$emit('kmDistance', self.googleDistance);
                            }
                        });
                    } else {
                        alert('Cannot find directions because: ' + status);
                    }
                });
            },

            showDivision: function(w) {
                var self = this;
                self.$http.get(self.urls.getWhLocation + w.ID)
                    .then(function (response) {
                        if (!response) {
                            return;
                        }
                        self.divisionLocation = response.data.coords;
                        var marker = new google.maps.Marker({
                            position: new google.maps.LatLng(response.data.coords.lat, response.data.coords.lng),
                            map: self.map
                        });

                        for (var i = 0; i < self.markers.length; i++) {
                            self.markers[i].setMap(null);
                        }
                        self.markers.push(marker);

                        self.addMarker(marker);
                        self.map.panTo( new google.maps.LatLng(response.data.coords.lat, response.data.coords.lng));
                        self.getZones(w);

                        Event.$emit('setDivision', {Lat: response.data.coords.lat, Lng: response.data.coords.lng})

                        var centerInSales = [50.2692, 19.05583]; // katowice
                        centerInSales = [51.76468, 18.06034]; // kalisz
                        centerInSales = [51.803787, 19.423388]; // lodz
                        centerInSales = [50.68096, 17.87439]; // opole
                        centerInSales = [52.53581, 19.75717]; // płock
                        centerInSales = [52.37172, 16.888746]; // poznan
                        centerInSales = [50.019, 22.006027]; // rzeszow
                        centerInSales = [50.585186, 22.057985]; // stalowa wola
                        centerInSales = [53.42478, 14.59297]; // szczecin
                        centerInSales = [50.764965, 16.258621]; // walbrzych
                        centerInSales = [51.054855, 16.976307]; // wroclaw
                        var radiousInSales = 21;
                        //self.drawCityCircle([response.data.coords.lat, response.data.coords.lng], 21);
                        //self.drawCityCircle([centerInSales[0], centerInSales[1]], radiousInSales);


                    });
            },

            getZones: function(w) {
                var self = this;
                this.zones = [];
                self.$http.get(self.urls.getZones + w.ID)
                    .then(function (response) {
                        if (response.data.zones.length > 0) {
                            self.zones = response.data.zones;
                            self.drawZones();
                        }
                    });
            },

            drawZones: function () {
                if (this.zones.length === 0) {
                    return;
                }
                for (var i = 0; i <this.mapZones.length; i++) {
                    this.mapZones[i].setMap(null);
                }
                for (var i = 0; i <this.zones.length; i++) {
                    var z = JSON.parse(this.zones[i].gjson);
                    console.log('-----------');
                    console.log(z.coordinates[0][0]);
                    console.log(z.coordinates[0]);
                    this.drawPolygon(z.coordinates[0]);
                }
            },

            drawPolygon: function (lineCoordinates) {
                var pointCount = lineCoordinates.length;
                var linePath = [];
                var str = '';
                for (var i = 0; i < pointCount; i++) {
                    var tempLatLng = new google.maps.LatLng( lineCoordinates[i][1] , lineCoordinates[i][0]);
                    linePath.push(tempLatLng);
                    str +=  lineCoordinates[i][0] + ',' +  lineCoordinates[i][1] + ' ';
                }
console.log(str)
console.log('----------------------')
                var lineOptions = {
                    path: linePath,
                    strokeWeight: 3,
                    strokeColor: '#959595',
                    strokeOpacity: 0.8,
                    fillColor: '#FFFF00',
                    fillOpacity: 0.06
                };
                var polygon = new google.maps.Polygon(lineOptions);
                this.mapZones.push(polygon);
                polygon.setMap(this.map);
            },

            drawCircle: function (point, radius, dir) {
                var d2r = Math.PI / 180;   // degrees to radians
                var r2d = 180 / Math.PI;   // radians to degrees
                var earthsradius = 6371; // 3963 is the radius of the earth in miles
                // 6371 - km

                var txt = 'POLYGON((';

                var points = 32;

                // find the raidus in lat/lon
                var rlat = (radius / earthsradius) * r2d;
                var rlng = rlat / Math.cos(point.lat() * d2r);

                var extp = new Array();
                if (dir==1) {
                    var start=0;
                    var end=points+1; // one extra here makes sure we connect the path
                } else {
                    var start=points+1;
                    var end=0;
                }
                for (var i=start; (dir==1 ? i < end : i > end); i=i+dir)
                {
                    var theta = Math.PI * (i / (points/2));
                    var ey = point.lng() + (rlng * Math.cos(theta)); // center a + radius x * cos(theta)
                    var ex = point.lat() + (rlat * Math.sin(theta)); // center b + radius y * sin(theta)
                    extp.push(new google.maps.LatLng(ex, ey));
                    txt += ey + ' ' + ex + ',';
                }
                txt += '))';
                this.circleTxt = txt;
                return extp;
            },
            drawCityCircle: function(centerPoint, r) {
                console.log('DRAW CITY CIRCLE');
                console.log(centerPoint);
                var self = this;
                //var radius = 11;
                //var centerPoint = [52.229676,  21.012229];
                var circle = new google.maps.Polygon({
                    map: self.map,
                    paths: [this.drawCircle(new google.maps.LatLng(centerPoint[0], centerPoint[1]), r, 1)],
                    strokeColor: "#000000",
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: "#FF0000",
                    fillOpacity: 0.35
                });
            },


            initMap: function () {
                google.maps.visualRefresh = true;
                var centerPoint = [52.229676,  21.012229];
                var zoomLevel = 10;
                this.map = new google.maps.Map(document.getElementById('myMap'), {
                    center: {lat: centerPoint[0], lng: centerPoint[1]},
                    scrollwheel: false,
                    zoom: zoomLevel
                })
                // this.makeRouteTest()
            },

            addMarker: function (lat, lng, label) {
                var coordinate = new google.maps.LatLng(lat, lng);
                var marker = new google.maps.Marker({
                    position: coordinate,
                    map: this.map,
                    title: '' + label
                });
                // If you don't specify a Map during the initialization //of the Marker you can add it later using the line //below
                marker.setMap(this.map);

            },

            drawLine: function (lineCoordinates) {
                var pointCount = lineCoordinates.length;
                var linePath = [];
                for (var i = 0; i < pointCount; i++) {
                    var tempLatLng = new google.maps.LatLng( lineCoordinates[i][1] , lineCoordinates[i][0]);
                    linePath.push(tempLatLng);
                }
                var lineOptions = {
                    path: linePath,
                    strokeWeight: 2,
                    strokeColor: '#FF0000',
                    strokeOpacity: 0.8
                }
                var polyline = new google.maps.Polyline(lineOptions);
                polyline.setMap(this.map);
            }

        }
    }
</script>

<style>
    #myMap{
        height: 500px;
    }
</style>



// WEBPACK FOOTER //
// CallCenterMap.vue?19beab23